export default class PhoneConfirmCode {
    Id: number = 0;
    Phone: string = '';
    OrganizationId: number = 0;
}